import { render, staticRenderFns } from "./BuddycomCallUserObject.vue?vue&type=template&id=309b27dc&scoped=true"
import script from "./BuddycomCallUserObject.vue?vue&type=script&lang=js"
export * from "./BuddycomCallUserObject.vue?vue&type=script&lang=js"
import style0 from "./BuddycomCallUserObject.vue?vue&type=style&index=0&id=309b27dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309b27dc",
  null
  
)

export default component.exports